import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule, CurrencyPipe, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';

import { BlockUIModule } from 'ng-block-ui';
import { ToastrModule } from 'ngx-toastr';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown-ivy';

import { SearchByTagPipe } from '@app/core/pipes/search-by-tag.pipe';
import { SafeHtmlPipe } from '@app/core/pipes/safe-html.pipe';
import { SafeUrlPipe } from '@app/core/pipes/safe-url.pipe';

import { ModalModule } from '@app/modal/modal.module';
import { SharedModule } from '@app/shared/shared.module';

import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';

import {GuidedTourModule, GuidedTourService} from 'ngx-guided-tour';

// PrimeNG 18+ deleted the old CSS-file theming this app used (angular.json's
// "resources/themes/tailwind-light/theme.css" + "resources/primeng.min.css" - both files
// no longer exist in the package). Replaced with the new JS theme-provider API below.
// Picked the Aura preset (PrimeNG's own default/recommended) since "tailwind-light" itself
// no longer has a direct equivalent - needs a visual pass over PrimeNG-heavy pages to confirm
// it's an acceptable look, not assumed to be a pixel-perfect match.
import { providePrimeNG } from 'primeng/config';
// @primeng/themes is discontinued - PrimeTek moved theme presets to @primeuix/themes.
// Same default export shape (a components map + css), pure rename for this app's usage.
import Aura from '@primeuix/themes/aura';

@NgModule({ declarations: [
        SearchByTagPipe,
        SafeHtmlPipe,
        SafeUrlPipe
    ],
    exports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        BlockUIModule,
        ToastrModule,
        ModalModule,
        SharedModule,
        SearchByTagPipe,
        SafeHtmlPipe,
        SafeUrlPipe,
        CurrencyPipe,
        DecimalPipe,
        AngularMultiSelectModule,
        MatChipsModule,
        MatFormFieldModule,
        MatIconModule,
        DragDropModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        GuidedTourModule,
    ], imports: [CommonModule,
        RouterModule,
        FormsModule,
        ToastrModule.forRoot(),
        BlockUIModule.forRoot(),
        ModalModule.forRoot(),
        MatFormFieldModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatDialogModule,
        GuidedTourModule], providers: [
        CurrencyPipe, DecimalPipe, DatePipe, MatNativeDateModule, GuidedTourService,
        // withFetch(): Angular 18 warns (NG02801) without it - fetch is recommended for SSR,
        // and no code here uses reportProgress (the main incompatibility with fetch backend)
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
        providePrimeNG({ theme: { preset: Aura,   options: { darkModeSelector: false } } })
    ] })
export class CoreModule { }